export default "__VITE_ASSET__Cw$okuF6__"